import { render, staticRenderFns } from "./ExemptionSave.vue?vue&type=template&id=1b279eff&"
import script from "./ExemptionSave.vue?vue&type=script&lang=js&"
export * from "./ExemptionSave.vue?vue&type=script&lang=js&"
import style0 from "./ExemptionSave.vue?vue&type=style&index=0&id=1b279eff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports